import ComponentManager from '@/Management/ComponentManager';
import ViewFactory from '@/Factories/ViewFactory';
import EmptyView from '@/Views/EmptyView';
import EmptyViewViewModel from '@/ViewModels/Views/EmptyViewViewModel';

export default class EmptyViewFactory extends ViewFactory {
    /**
     * @override
     */
    public viewModel: EmptyViewViewModel;
    
    constructor(params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Body';
    }

    /**
     * @override
     */
    public getView(): JQuery<HTMLElement> {
        if (this.viewModel == null) {
            this.viewModel = this.createViewModel();
        }
        
        if (this.view == null) {
            this.view = this.createView(this.viewModel);
        }

        const tuple = this.view.getTuple();
        return tuple.view;
    }

    public createView(viewModel: EmptyViewViewModel): EmptyView {
        const emptyView = ComponentManager.getView<typeof EmptyView>('EmptyView');
        return new emptyView(viewModel, this.createRootElement('Empty'));
    }
    
    private createViewModel(): EmptyViewViewModel {
        const emptyViewViewModel = ComponentManager.getViewModel<typeof EmptyViewViewModel>('EmptyViewViewModel');
        return new emptyViewViewModel({
            viewFactory: this
        });
    }
}

ComponentManager.setFactory('EmptyView', EmptyViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('Empty', EmptyViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');